<template>
  <CoreHeader/>
  <BlockHeadline
    :className="['pt-large', 'bg-color-dark-blue']"
  />
  <BlockWedge
    :className="['wedge-photo-left']"
    :imgUrl="'reviewing-data.jpg'"
    :beforeBgColor="'--dark-blue'" 
    :afterBgColor="'--light-gray'"
  />
  <BlockCarousel
    :sectionID="'section-services'"
    :className="['pb-large', 'bg-color-soft']"
  />
  <BlockStoreGrid
    :sectionID="'section-clients'"
    :className="['bg-color-white']"
  />
  <BlockWedge
    :className="['wedge-photo-right']"
    :imgUrl="'sticky-note-collaboration.jpg'"
    :beforeBgColor="'--white'" 
    :afterBgColor="'--light-blue'"
  />
  <BlockTeamGrid
    :sectionID="'section-team'"
    :className="['bg-color-light-blue']"
  />
  <BlockContactForm
    :sectionID="'section-contact'"
    :className="['bg-color-dark-blue']"
  />
  <CoreFooter/>
</template>

<script>
import CoreHeader from './components/core/Header.vue';
import BlockHeadline from './components/blocks/Headline.vue';
import BlockWedge from './components/blocks/Wedge.vue';
import BlockCarousel from './components/blocks/Carousel.vue';
import BlockStoreGrid from './components/blocks/StoreGrid.vue';
import BlockTeamGrid from './components/blocks/TeamGrid.vue';
import BlockContactForm from './components/blocks/ContactForm.vue';
import CoreFooter from './components/core/Footer.vue';

export default {
  name: 'App',
  components: {
    CoreHeader,
    BlockHeadline,
    BlockWedge,
    BlockCarousel,
    BlockStoreGrid,
    BlockTeamGrid,
    BlockContactForm,
    CoreFooter
  },
  
  data() {
    return {
      resizeTimeout: null,
    };
  },
  
  methods: {
    setHeaderHeight() {
      this.$nextTick(() => {
        const header = document.getElementById("header");
        if (header) {
          document.documentElement.style.setProperty("--header-height", `${header.offsetHeight}px`);
        }
      });
    },

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        requestAnimationFrame(this.setHeaderHeight);
      }, 200); // 200ms debounce
    },
  },
  
  mounted() {
    this.setHeaderHeight();
    window.addEventListener("resize", this.handleResize);
  },
  
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss">
@import "@/scss/main.scss";
@import "@/scss/variables-css.scss";
</style>